<template>
  <div v-if="aberto" class="painel-confirm-modal">
    <div class="painel-confirm-modal__overlay" @click.self="cancelar">
      <div
        class="painel-confirm-modal__container"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
      >
        <header class="painel-confirm-modal__header">
          <h2 :id="titleId">{{ titulo }}</h2>
          <button
            type="button"
            class="painel-confirm-modal__close"
            aria-label="Fechar"
            :disabled="loading"
            @click="cancelar"
          >
            &times;
          </button>
        </header>

        <div class="painel-confirm-modal__body">
          <p class="painel-confirm-modal__message">{{ mensagem }}</p>
        </div>

        <footer class="painel-confirm-modal__footer">
          <button
            type="button"
            class="painel-confirm-modal__btn painel-confirm-modal__btn--cancel"
            :disabled="loading"
            @click="cancelar"
          >
            {{ cancelarTexto }}
          </button>
          <button
            type="button"
            class="painel-confirm-modal__btn"
            :class="confirmButtonClass"
            :disabled="loading"
            @click="confirmar"
          >
            {{ loading ? confirmarTextoLoading : confirmarTexto }}
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
let modalInstanceCount = 0;

export default {
  name: 'PainelConfirmModal',

  props: {
    aberto: {
      type: Boolean,
      required: true
    },
    mensagem: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      default: 'Confirmar'
    },
    confirmarTexto: {
      type: String,
      default: 'Confirmar'
    },
    confirmarTextoLoading: {
      type: String,
      default: 'Aguarde...'
    },
    cancelarTexto: {
      type: String,
      default: 'Cancelar'
    },
    loading: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'danger'].includes(value)
    }
  },

  data() {
    modalInstanceCount += 1;
    return {
      titleId: `painel-confirm-modal-title-${modalInstanceCount}`
    };
  },

  computed: {
    confirmButtonClass() {
      return this.variant === 'danger'
        ? 'painel-confirm-modal__btn--danger'
        : 'painel-confirm-modal__btn--confirm';
    }
  },

  methods: {
    confirmar() {
      if (this.loading) {
        return;
      }

      this.$emit('confirmar');
    },

    cancelar() {
      if (this.loading) {
        return;
      }

      this.$emit('cancelar');
    }
  }
};
</script>

<style scoped>
.painel-confirm-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(0, 0, 0, 0.55);
}

.painel-confirm-modal__container {
  width: 100%;
  max-width: 420px;
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.painel-confirm-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  color: #fff;
  background: #005b61;
}

.painel-confirm-modal__header h2 {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
}

.painel-confirm-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  color: #005b61;
  font-size: 1.5rem;
  line-height: 1;
  background: #fff;
  cursor: pointer;
}

.painel-confirm-modal__close:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.painel-confirm-modal__body {
  padding: 1.25rem 1.25rem 0.5rem;
}

.painel-confirm-modal__message {
  margin: 0;
  color: #374151;
  font-size: 0.9375rem;
  line-height: 1.5;
}

.painel-confirm-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.25rem 1.25rem;
}

.painel-confirm-modal__btn {
  min-width: 6.5rem;
  padding: 0.625rem 1rem;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.painel-confirm-modal__btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.painel-confirm-modal__btn--cancel {
  color: #374151;
  background: #e5e7eb;
}

.painel-confirm-modal__btn--cancel:hover:not(:disabled) {
  background: #d1d5db;
}

.painel-confirm-modal__btn--confirm {
  color: #fff;
  background: #005b61;
}

.painel-confirm-modal__btn--confirm:hover:not(:disabled) {
  background: #004850;
}

.painel-confirm-modal__btn--danger {
  color: #fff;
  background: #b91c1c;
}

.painel-confirm-modal__btn--danger:hover:not(:disabled) {
  background: #991b1b;
}
</style>
